import HeroLogo from '$/public/logo/surselva-logo.svg'
import { Typo3SectionSpotHeadlessHeroHome } from '@/types/typo3'
import { SectionIntro } from '@/ui/Sections'
import { BookingBar, Button, Container, Img, Section } from '@/ui/components'
import Title from '@/ui/components/Base/Title'
import { memo } from 'react'
import BackgroundVideo from './BackgroundVideo'

const SectionHeroHome = ({
  data
}: {
  data: Typo3SectionSpotHeadlessHeroHome
}) => (
  <>
    <Section data={data} className="s-section-hero-home py-0!">
      <div className="bg-primary-400 relative flex w-full items-center overflow-hidden">
        <Container className="relative z-10 flex h-[calc(100vh-64px)] min-h-[90vh] flex-1 flex-col justify-between sm:h-full">
          <div className="min-h-20"></div>
          <div className="gap-gutter flex flex-col-reverse justify-between text-white md:flex-row md:items-center">
            <div className="gap-lg flex flex-col items-start">
              <hgroup>
                {data?.overline && (
                  <Title as="h2" className="h5 text-white">
                    {data?.overline}
                  </Title>
                )}
                <Title as={'h1'} className="h1">
                  {data.title}
                </Title>
              </hgroup>
              {data?.button?.link?.title && (
                <Button
                  href={data?.button?.link?.href}
                  className={data?.button?.link?.class || undefined}
                  target={data?.button?.link?.target || undefined}
                  mode="invert"
                  variant={data?.button?.variant || 'primary'}
                  size={'l'}
                  aria-label="Go to section"
                  iconPosition={data?.button?.iconPosition}
                  icon={data?.button?.icon}
                >
                  {data?.button?.link?.title}
                </Button>
              )}
            </div>
            {process.env.NEXT_PUBLIC_PROJECT === 'surselva' && (
              <div>
                <div className="max-w-[8vw]">
                  <HeroLogo className="w-full" />
                </div>
              </div>
            )}
          </div>
          <div className="mb-lg">
            {data?.showOnlineBooking && <BookingBar />}
          </div>
        </Container>

        <div className="absolute inset-0 z-5 bg-black/20"></div>

        {data?.isImages && data?.images && data?.images?.length > 0 && (
          <Img
            data={data?.images[0]}
            naked={true}
            objectCover
            className="absolute inset-0 h-full w-full"
            fetchPriority="high"
            loading="eager"
            priority
          />
        )}

        <BackgroundVideo
          isVideo={data?.isVideo}
          videoMuxCode={data?.videoMuxCode}
        />
      </div>
    </Section>
    <SectionIntro
      title={data?.leadText?.title}
      text={data?.leadText?.text}
      section={{
        ...data,
        type: 'spotheadless_intro'
      }}
    />
  </>
)

SectionHeroHome.displayName = 'SectionHeroHome'

export default memo(SectionHeroHome)
